"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleCommands = void 0;
const commands_1 = require("./commands");
class GoogleCommands {
    constructor(config) {
        this.config = config;
    }
    doTrackSignInEvent(input) {
        return Promise.resolve();
    }
    doTrackSignUpEvent(input) {
        return Promise.resolve();
    }
    doTrackIdentifyUserEvent(input) {
        return Promise.resolve();
    }
    doTrackViewContentEvent(input) {
        const command = new commands_1.ViewContentCommand(input);
        return command.execute(this.config);
    }
    doTrackAddToCartEvent(input) {
        const command = new commands_1.AddToCartCommand(input);
        return command.execute(this.config);
    }
    doTrackRemoveFromCartEvent(input) {
        return Promise.resolve();
    }
    doTrackSearchEvent(input) {
        const command = new commands_1.SearchCommand(input);
        return command.execute(this.config);
    }
    doTrackInitiateCheckoutEvent(input) {
        const command = new commands_1.InitiateCheckoutCommand(input);
        return command.execute(this.config);
    }
    doTrackAddPaymentInfoEvent(input) {
        const command = new commands_1.AddPaymentInfoCommand(input);
        return command.execute(this.config);
    }
    doTrackPurchaseEvent(input) {
        const command = new commands_1.PurchaseCommand(input);
        return command.execute(this.config);
    }
    doTrackPromotionCodeUsedEvent(input) {
        return Promise.resolve();
    }
    doTrackEventByConversionApi(input) {
        return Promise.resolve();
    }
    doTrackFestivalFormStartEvent(input) {
        const command = new commands_1.FestivalFormStartCommand(input);
        return command.execute(this.config);
    }
    doTrackFestivalSuccessEvent(input) {
        const command = new commands_1.FestivalSuccessCommand(input);
        return command.execute(this.config);
    }
}
exports.GoogleCommands = GoogleCommands;
